import React from "react"

import { ApiResponse } from "shared/types/ApiResponse"

import { TeamMember } from "entities/team-members/types/TeamMember"
import { TeamMemberListProps } from "entities/team-members/ui/team-member-list/TeamMemberList"
import { Team } from "entities/teams/types/Team"
import { CreateTeamMemberFormData } from "features/team-member-management/types/CreateTeamMemberFormData"

import { useManageTeamOverlayViewModel } from "./model/useManageProjectTeamOverlayViewModel"
import { ManageProjectTeamOverlayView } from "./ui/ManageProjectTeamOverlayView"

export interface ManageProjectTeamOverlayModel {
  team: Team | null | undefined
  projectID: string
  isLoadingTeam?: boolean
  currentUserEmail?: string
  existingTeamMemberEmails?: string[]

  onUpdateTeamMember: TeamMemberListProps["onUpdate"]
  onDeleteTeamMember: TeamMemberListProps["onDelete"]
  onResendInvitation: TeamMemberListProps["onResendInvitation"]
  onInviteMore?: () => void
  onSubmit: (
    formData: CreateTeamMemberFormData
  ) => void | Promise<ApiResponse<TeamMember[]>>
}

export interface ManageProjectTeamOverlayProps
  extends ManageProjectTeamOverlayModel {}

export const ManageProjectTeamOverlay = React.memo(
  (props: ManageProjectTeamOverlayProps) => (
    <ManageProjectTeamOverlayView {...useManageTeamOverlayViewModel(props)} />
  )
)
